import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import CycleCount03Actions, { CycleCount03Types } from '../Stores/CycleCount03/Actions';

const getAppStore = state => state.app;

export function* cycleCount03FetchCycleCount03({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(CycleCount03Actions.cycleCount03FetchCycleCount03Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `cycleCount/indexProcess/CYCLE_COUNT_03/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        CycleCount03Actions.cycleCount03FetchCycleCount03Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CycleCount03Actions.cycleCount03FetchCycleCount03Loading(false));
  }
}

export function* cycleCount03PrintCycleCount03({ hdrIds }) {
  try {
    yield put(CycleCount03Actions.cycleCount03PrintCycleCount03Loading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `cycleCount/printProcess/CYCLE_COUNT_03/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      const selectedDocuments = hdrIds.map(d => ({ id: d }));

      FileSaver.saveAs(result.data, 'CycleCount.pdf');
      yield put(CycleCount03Actions.cycleCount03RemoveSelectedDocuments(selectedDocuments));
      yield put(CycleCount03Actions.cycleCount03ResetTimestamp());
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CycleCount03Actions.cycleCount03PrintCycleCount03Loading(false));
  }
}

export function* cycleCount03GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/cycleCountDetail/update/${hdrId}`));
}

export function* cycleCount03NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/cycleCountDetail/create/${app.curSiteFlowId}`));
}

export const saga = [
  takeLatest(CycleCount03Types.CYCLE_COUNT03_GO_TO_DOCUMENT, cycleCount03GoToDocument),
  takeLatest(CycleCount03Types.CYCLE_COUNT03_NEW_DOCUMENT, cycleCount03NewDocument),
  takeLatest(CycleCount03Types.CYCLE_COUNT03_FETCH_CYCLE_COUNT03, cycleCount03FetchCycleCount03),
  takeLatest(CycleCount03Types.CYCLE_COUNT03_PRINT_CYCLE_COUNT03, cycleCount03PrintCycleCount03)
];
